/* eslint-disable camelcase */
import React from "react";
import { JobSearchData } from "@themuse/design-system";
import { triggerSnowplowClickEvent } from "@themuse/snowplow-js-client";

import { truncateStringWithEllipsis } from "utils/strings";

import styles from "./JobIndividualSidebar.module.scss";

interface SidebarJobTileProps {
    jobSearchData: JobSearchData;
    orderNum: number;
}

export const SidebarJobTile = React.forwardRef((props: SidebarJobTileProps, ref: any) => {
    const { jobSearchData, orderNum } = props;
    const {
        title,
        short_title,
        company,
        remote_work_location_type,
        locations
    } = jobSearchData;
    const location = remote_work_location_type === "virtual" ? "Remote" : locations[0]?.address;
    const trackingProps = JSON.stringify({
        sp_impression_component: "tile",
        sp_impression_tile_type: "job",
        sp_impression_insert_type: null,
        sp_impression_modal_type: null,
        sp_impression_position: "right_rail",
        sp_tile_type: "job",
        sp_tile_entity_id: jobSearchData.legacy_id.toString(),
        sp_tile_entity_uuid: jobSearchData.id.toString(),
        sp_tile_order: orderNum,
        sp_tile_location: "similar_jobs",
        sp_tile_company_id: company?.legacy_id.toString(),
        sp_click_component: "tile",
        sp_click_component_tile_type: "job",
        sp_click_position: "right_rail",
        sp_click_target_page_section: "job_detail",
    });

    return (
        <li
            ref={ref}
            data-tracking-event-type="impression"
            data-tracking-props={trackingProps}
        >
            <a
                className={styles.jobTileLink}
                href={`/jobs/${company?.short_name}/${short_title}`}
                target="_blank"
                onClick={() => triggerSnowplowClickEvent(JSON.parse(trackingProps))}
            >
                {truncateStringWithEllipsis(title, 75)}
            </a>
            <p>{truncateStringWithEllipsis(company?.name, 25)}</p>
            <p>{location}</p>
        </li>
    );
});
SidebarJobTile.displayName = "SidebarJobTile";
